<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @search="search" @reflash="reflash" @exps="exps" @save="save"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left1" ref="left1">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="PROFACHECK"
                        :filter_language="['check_result1','check_result2']"
                        :filter_thousandth="['plan_qty','check_qty1','check_qty2']"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="editInfo"
                        ref="singleTable"
                        :checkflg="false"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        @row-click="editInfo"
                        :height="tableHeight"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4285]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="plan_qty" :label="$t('getapi[4516]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="check_qty1" :label="$t('getapi[7078]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="check_date1" :label="$t('getapi[7079]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="check_result1" :label="$t('getapi[7080]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="check_person1" :label="$t('getapi[7081]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="check_qty2" :label="$t('getapi[7082]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="check_date2" :label="$t('getapi[7083]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="check_result2" :label="$t('getapi[7084]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="check_person2" :label="$t('getapi[7085]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid1" ref="mid1">

                <div style="width:660px">
                    <table>
                        <tr>
                            <td style="width:220px" colspan="2">
                                <el-divider content-position="left">{{$t('getapi[7086]')}}</el-divider>
                            </td>
                            <td style="width:220px" colspan="2">
                                <el-divider content-position="left">{{$t('getapi[7087]')}}</el-divider>
                            </td>
                            <td style="width:220px" colspan="2">
                                <el-divider content-position="left">{{$t('getapi[7088]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:60px">{{$t('getapi[4285]')}}</td>
                            <td style="width:160px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.so_code" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{$t('getapi[7078]')}}</td>
                            <td style="width:160px">
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.check_qty1" :readonly="btn.canEditC" :class="{'readO':btn.canEditC}"></el-input>
                            </td>
                            <td style="width:60px">{{$t('getapi[7082]')}}</td>
                            <td style="width:160px">
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.check_qty2" :readonly="btn.canEditF" :class="{'readO':btn.canEditF}"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[112]')}}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.part_code" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[7079]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.check_date1" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{$t('getapi[7083]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.check_date2" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[149]')}}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.part_version" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[7080]')}}</td>
                            <td>
                                <el-select filterable v-model="dataDetail.Head.check_result1" size="mini" :disabled="btn.canEditC">
                                    <el-option key="合格" :label="$t('getapi[1461]')" value='合格'></el-option>
                                    <el-option key="不合格" :label="$t('getapi[7089]')" value='不合格'></el-option>
                                </el-select>
                            </td>
                            <td>{{$t('getapi[7084]')}}</td>
                            <td>
                                <el-select filterable v-model="dataDetail.Head.check_result2" size="mini" :disabled="btn.canEditF">
                                    <el-option key="合格" :label="$t('getapi[1461]')" value='合格'></el-option>
                                    <el-option key="不合格" :label="$t('getapi[7089]')" value='不合格'></el-option>
                                </el-select>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[4516]')}}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.plan_qty" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[7081]')}}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.check_person1" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[7085]')}}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.check_person2" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="PROFACHECK" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6585]')" queryData="PROFACHECK" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '2_facheck',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_facheck'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                loading: false, // 主表加载状态
                dataDetail:{
                    Head:{},
                },
                code: '',
                btn:{
                    canEditC: true,
                    canEditF: true
                },
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.$limits.dragControllerDiv1();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('PROFACHECK', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6585]"),this.$t("getapi[25]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.$limits.authority('plv2', 247, 1) > 0){
                    if (that.total > 0) {
                        if(that.code != ''){
                            that.$refs.SetBtn.SetButtonEnable('save,search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this
            },
            leftt(e) {
                var left = document.getElementsByClassName('left1');
                var mid = document.getElementsByClassName('mid1');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.getPageSize('2_facheck')
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'PROFACHECK');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/Pro/SO/FACheckViewDataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.authority();
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this
                if(that.code == row.so_code){
                    return
                }
                that.code = row.so_code
                that.getDetail(row.so_code)
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pro/SO/FACheckViewExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "PROFACHECK",
                    fromname: that.$t('getapi[6585]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                if(that.dataDetail.Head.check_result1 == '合格' && that.dataDetail.Head.check_qty1==0){
                    that.$message.warning(that.$t('getapi[12500]'))
                    return false
                }
                let parm = that.dataDetail.Head
                that.$http.urlpost('/Pro/SO/SaveFACheck', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            getDetail(code) {
                let that = this;
                that.addoredit = 1
                let parm = {
                    Code: code
                };
                that.$http.urlpost('/Pro/SO/GetFaCheckInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.btn.canEditC = that.dataDetail.Head.check_result1 != '' || that.dataDetail.Head.check_result2 != ''
                        that.btn.canEditF = that.dataDetail.Head.check_result1 != '不合格' || that.dataDetail.Head.check_result2 != ''
                        that.authority();
                        that.btnauthority()
                    }
                });
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        background: #ff7879;
    }
</style>
